module.exports = "/templates/bds/public/images/542dc4d951034e38f59963951dd05ea2.png";